document.addEventListener('DOMContentLoaded', function() {
  // Only run on refund policy page
  if (window.location.pathname.includes('/policies/refund')) {
    const policyTitle = document.querySelector('.shopify-policy__title');
    if (policyTitle) {
      policyTitle.textContent = 'Return and Refund Policy';
      policyTitle.style.lineHeight = '1.3';
      policyTitle.style.marginBottom = '1.5rem';
      policyTitle.style.fontWeight = '700';
      policyTitle.style.visibility = 'visible';
      policyTitle.style.height = 'auto';
      
      // Set font size based on screen width
      if (window.innerWidth <= 749) {
        policyTitle.style.fontSize = '2.5rem';  // Mobile size - change this value
      } else {
        policyTitle.style.fontSize = '1.50rem';  // Desktop size
      }
    }
  }
});
